import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

export const useSherwinCouponCardStyles = makeStyles((theme: Theme) => ({
  couponContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: 500,
    height: 450,

    [theme.breakpoints.down('md')]: {
      maxWidth: 400,
      height: 380
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: 550,
      height: 495
    }
  },
  couponBackground: {
    position: 'absolute',
    width: '100%',
    maxWidth: '483.198px',
    height: '484.522px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 0,

    [theme.breakpoints.down('md')]: {
      maxWidth: '320px',
      height: '320px'
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: '400px',
      height: '400px'
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '420px',
      height: '420px'
    },
    '@media (min-width: 1850px)': {
      maxWidth: '442.932px',
      height: '444.174px'
    }
  },
  couponCard: {
    position: 'absolute',
    width: '85%',
    maxWidth: '502.323px',
    height: '302.317px',
    borderRadius: '23.763px',
    border: '1.213px solid #B4BED0',
    backgroundColor: '#EBEFF5',
    padding: theme.spacing(3.3, 4.4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    boxShadow: theme.shadows[8],
    zIndex: 1,
    overflow: 'hidden',
    top: '50%',
    left: '50%',
    transform: 'translate(calc(-50% + 74.02px), -50%)',

    [theme.breakpoints.down('md')]: {
      maxWidth: '360px',
      height: '220px',
      padding: theme.spacing(2.5, 3),
      transform: 'translate(calc(-50% + 53px), -50%)'
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: '453px',
      height: '273px',
      transform: 'translate(calc(-50% + 67px), -50%)',
      borderRadius: '21.5px',
      padding: theme.spacing(3, 4)
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '476px',
      height: '286px',
      transform: 'translate(calc(-50% + 70px), -50%)',
      borderRadius: '22.5px'
    },
    '@media (min-width: 1850px)': {
      maxWidth: '502.323px',
      height: '302.317px',
      transform: 'translate(calc(-50% + 74.02px), -50%)',
      borderRadius: '23.763px',
      padding: theme.spacing(3.3, 4.4)
    }
  },
  sherwinLogo: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(-1.5),
    marginLeft: theme.spacing(-1.5),
    flexShrink: 0,
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(1.65),
      marginTop: theme.spacing(-1.65),
      marginLeft: theme.spacing(-1.65)
    }
  },
  logoImage: {
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    display: 'block',

    [theme.breakpoints.down('md')]: {
      maxHeight: '75px'
    },

    [theme.breakpoints.up('lg')]: {
      maxHeight: '110px'
    },

    [theme.breakpoints.up('xl')]: {
      maxHeight: '110px'
    }
  },
  couponContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    minHeight: 0,
    overflow: 'visible',
    gap: 0,
    marginTop: theme.spacing(-3),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(-3.3)
    }
  },
  couponAmount: {
    color: '#383A36',
    fontFamily: 'Euclid',
    fontSize: '94.59px',
    fontWeight: 600,
    lineHeight: '1',
    letterSpacing: '-2.838px',
    textAlign: 'center',
    width: '100%',
    flexShrink: 0,
    margin: 0,
    marginBottom: theme.spacing(-1.5),

    [theme.breakpoints.down('md')]: {
      fontSize: '76px',
      letterSpacing: '-2.28px',
      lineHeight: '1',
      marginBottom: theme.spacing(-1.5)
    },

    [theme.breakpoints.up('lg')]: {
      fontSize: '104.049px',
      letterSpacing: '-3.1215px',
      lineHeight: '1',
      marginBottom: theme.spacing(-1.65)
    },

    [theme.breakpoints.up('xl')]: {
      fontSize: '104.049px',
      letterSpacing: '-3.1215px',
      lineHeight: '1',
      marginBottom: theme.spacing(-1.65)
    }
  },
  couponLabel: {
    width: '191.983px',
    color: '#373A36',
    textAlign: 'center',
    fontFamily: 'Inter, sans-serif',
    fontSize: '34.172px',
    fontWeight: 600,
    lineHeight: '140%',
    letterSpacing: '-0.683px',
    margin: 0,
    whiteSpace: 'nowrap',
    flexShrink: 0,

    [theme.breakpoints.down('md')]: {
      fontSize: '28px',
      width: 'auto',
      letterSpacing: '-0.56px',
      minWidth: '150px'
    },

    [theme.breakpoints.up('lg')]: {
      width: '211.181px',
      fontSize: '37.589px',
      letterSpacing: '-0.7518px'
    },

    [theme.breakpoints.up('xl')]: {
      width: '211.181px',
      fontSize: '37.589px',
      letterSpacing: '-0.7518px'
    }
  }
}))
